import React from 'react';
import { Breadcrumb as BreadcrumbBoot } from 'react-bootstrap';
import Link from '@/Shared/Link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';

export default function Breadcrumb({items, ...props}) {
	if (items!=0) items.splice(0,0, {
		href: route('inicio'), children: <FontAwesomeIcon icon={faHome} />
	});
	return <BreadcrumbBoot {...props}>
		{(items||[]).filter(itm=>itm && !itm.hide).map(({hide, ...itm}, idx)=>{
			const baseProps = {linkAs: Link};
			//if (itm.active) baseProps.linkAs = undefined;
			return <BreadcrumbBoot.Item {...baseProps} key={'breadcrumb-i-'+idx} {...itm} />
		})}
	</BreadcrumbBoot>
}
